(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-row"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.collectionRowHoverWaveInitialized) return;
    window.collectionRowHoverWaveInitialized = true;

    const duration = 700;
    const hiddenPath = 'M1 1H0V1H1Z';
    const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
    const lerp = (start, end, value) => start + (end - start) * value;

    const wavePath = (revealValue) => {
      const reveal = clamp(revealValue, 0, 1);
      const offset = 1 - reveal;
      const fadeProgress = clamp((reveal - 0.84) / 0.16, 0, 1);
      const fade = easeOutCubic(fadeProgress);
      const y0 = lerp(0.014193 + offset, offset, fade);
      const c1y = lerp(0.014073 + offset, offset, fade);
      const c2y = lerp(-0.041858 + offset, offset, fade);
      const c3y = lerp(0.082988 + offset, offset, fade);
      const c4y = lerp(0.207834 + offset, offset, fade);
      const c5y = lerp(0.001454 + offset, offset, fade);

      return `M1 1H0L0 ${y0}C-0.000145 ${c1y} 0.198726 ${c2y} 0.5 ${c3y}C0.801274 ${c4y} 1 ${c5y} 1 ${c5y}V1Z`;
    };

    const getPath = (card) => card?.querySelector('[data-collection-row-hover-path]');

    const setReveal = (path, value) => {
      const reveal = clamp(value, 0, 1);
      path.dataset.hoverReveal = String(reveal);
      path.setAttribute('d', reveal === 0 ? hiddenPath : wavePath(reveal));
    };

    const animateCard = (card, targetValue) => {
      const path = getPath(card);
      if (!path) return;

      const from = Number(path.dataset.hoverReveal || 0);
      const target = clamp(targetValue, 0, 1);

      if (path.hoverWaveFrame) cancelAnimationFrame(path.hoverWaveFrame);

      if (reducedMotionQuery.matches) {
        setReveal(path, target);
        return;
      }

      const startedAt = performance.now();

      const step = (now) => {
        const progress = clamp((now - startedAt) / duration, 0, 1);
        const reveal = lerp(from, target, easeOutCubic(progress));
        setReveal(path, reveal);

        if (progress < 1) {
          path.hoverWaveFrame = requestAnimationFrame(step);
        } else {
          setReveal(path, target);
          path.hoverWaveFrame = null;
        }
      };

      path.hoverWaveFrame = requestAnimationFrame(step);
    };

    document.addEventListener(
      'pointerover',
      (event) => {
        if (!hoverQuery.matches) return;
        const card = event.target.closest('.collection-row-card');
        if (!card || card.contains(event.relatedTarget)) return;
        animateCard(card, 1);
      },
      true
    );

    document.addEventListener(
      'pointerout',
      (event) => {
        if (!hoverQuery.matches) return;
        const card = event.target.closest('.collection-row-card');
        if (!card || card.contains(event.relatedTarget)) return;
        animateCard(card, 0);
      },
      true
    );

    document.addEventListener('focusin', (event) => {
      const card = event.target.closest('.collection-row-card');
      if (card) animateCard(card, 1);
    });

    document.addEventListener('focusout', (event) => {
      const card = event.target.closest('.collection-row-card');
      if (!card || card.contains(event.relatedTarget)) return;
      animateCard(card, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.upwardScrollDistance = 0;
      this.revealScrollThreshold = 32;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
        this.upwardScrollDistance = 0;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.clearTimeout(this.isScrolling);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const upwardScroll = this.currentScrollTop - scrollTop;

      if (upwardScroll > 0 && scrollTop > this.headerCoords.bottom && !this.preventReveal) {
        this.upwardScrollDistance += upwardScroll;
      } else {
        this.upwardScrollDistance = 0;
      }

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          if (this.upwardScrollDistance >= this.revealScrollThreshold) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy?.getAttribute('data-media-id');
      const modalSlides = Array.from(this.querySelectorAll('[data-media-modal-id]'));
      const activeIndex = modalSlides.findIndex((slide) => slide.dataset.mediaModalId.endsWith(`-${mediaId}`));
      const activeSlide = modalSlides[activeIndex];

      if (activeIndex >= 0) {
        queueMicrotask(() => this.querySelector('.js-popup-slider')?.swiper?.slideTo(activeIndex, 0));
      }

      const activeMedia = activeSlide?.querySelector(`[data-media-id="${mediaId}"]`);

      if (
        activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buybox"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get("product-buybox-card")) {
    customElements.define(
      "product-buybox-card",
      class ProductBuyboxCard extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;

          this.card = this.closest("[data-buybox-card]");
          this.mediaWrap = this.card?.querySelector("[data-media-wrap]");
          this.mainMedia = this.card?.querySelector("[data-media-main]");
          this.priceWrap = this.card?.querySelector("[data-price-wrap]");
          this.variantIdInput = this.querySelector("[data-variant-id-input]");
          this.addButton = this.querySelector('[name="add"]');
          this.addLabel = this.querySelector("[data-add-label]");
          this.bundlePicker = this.querySelector("bundle-picker");
          this.optionFieldsets = Array.from(this.querySelectorAll("[data-option-index]"));
          this.moneyFormat = this.dataset.moneyFormat || "$0.00";
          this.variants = this.parseVariants();
          this.currentVariant = this.variants.find((variant) => String(variant.id) === this.variantIdInput?.value) || this.variants[0] || null;
          this.baseVariantId = this.currentVariant ? String(this.currentVariant.id) : "";

          this.onOptionChange = this.handleOptionChange.bind(this);
          this.onThumbClick = this.handleThumbClick.bind(this);

          this.optionFieldsets.forEach((fieldset) => {
            fieldset.addEventListener("change", this.onOptionChange);
          });

          this.card?.querySelectorAll("[data-media-thumb]").forEach((thumb) => {
            thumb.addEventListener("click", this.onThumbClick);
          });

          if (this.mainMedia && this.mainMedia.complete) {
            this.mediaWrap?.classList.remove("is-loading");
          } else if (this.mainMedia) {
            this.mainMedia.addEventListener(
              "load",
              () => {
                this.mediaWrap?.classList.remove("is-loading");
              },
              { once: true }
            );
          }

          this.refreshOptionAvailability();
          this.renderVariantState();
        }

        disconnectedCallback() {
          this.optionFieldsets.forEach((fieldset) => {
            fieldset.removeEventListener("change", this.onOptionChange);
          });
          this.card?.querySelectorAll("[data-media-thumb]").forEach((thumb) => {
            thumb.removeEventListener("click", this.onThumbClick);
          });
          this.initialized = false;
        }

        parseVariants() {
          const jsonNode = this.querySelector("[data-variants]");
          if (!jsonNode) return [];
          try {
            return JSON.parse(jsonNode.textContent);
          } catch (error) {
            console.error("Product buybox: failed parsing variant JSON", error);
            return [];
          }
        }

        getSelectedOptions() {
          return this.optionFieldsets.map((fieldset) => {
            const checked = fieldset.querySelector("input:checked");
            return checked ? checked.value : "";
          });
        }

        findMatchingVariant(selectedOptions) {
          return this.variants.find((variant) => {
            if (!variant.options) return false;
            return variant.options.every((value, index) => value === selectedOptions[index]);
          });
        }

        handleOptionChange() {
          const selectedOptions = this.getSelectedOptions();
          const matchingVariant = this.findMatchingVariant(selectedOptions);
          if (matchingVariant) {
            this.currentVariant = matchingVariant;
            this.baseVariantId = String(matchingVariant.id);
          }
          this.refreshOptionAvailability();
          this.renderVariantState();
        }

        refreshOptionAvailability() {
          const currentSelections = this.getSelectedOptions();

          this.optionFieldsets.forEach((fieldset, optionIndex) => {
            const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
            inputs.forEach((input) => {
              const simulatedSelections = [...currentSelections];
              simulatedSelections[optionIndex] = input.value;

              const hasCombination = this.variants.some((variant) => {
                return simulatedSelections.every((value, idx) => !value || variant.options[idx] === value);
              });

              input.disabled = !hasCombination;
            });
          });
        }

        handleThumbClick(event) {
          const button = event.currentTarget;
          const mediaSrc = button.dataset.mediaSrc;
          if (!this.mainMedia || !mediaSrc) return;

          this.card?.querySelectorAll("[data-media-thumb]").forEach((thumb) => {
            thumb.classList.remove("is-active");
          });
          button.classList.add("is-active");
          this.mainMedia.src = mediaSrc;
          this.mediaWrap?.classList.add("is-loading");
        }

        renderVariantState() {
          const variant = this.currentVariant;
          if (!variant) return;

          if (this.variantIdInput) {
            const nextVariantId = this.baseVariantId || String(variant.id);
            const hasChanged = String(this.variantIdInput.value) !== String(nextVariantId);
            this.variantIdInput.value = nextVariantId;
            this.variantIdInput.disabled = !variant.available;
            if (hasChanged) {
              this.variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
            }
          }

          this.toggleAddButton(!variant.available);
          this.renderPrice(variant.price, variant.compare_at_price);
          this.syncSelectedOptionLabels();

          if (this.bundlePicker && this.baseVariantId) {
            this.bundlePicker.dataset.currentVariantId = this.baseVariantId;
            if (typeof this.bundlePicker.syncBundleMarkup === "function") {
              this.bundlePicker.syncBundleMarkup(
                this.baseVariantId,
                this.card?.dataset.sectionId || this.bundlePicker.dataset.section
              );
            }
          }
        }

        syncSelectedOptionLabels() {
          this.optionFieldsets.forEach((fieldset) => {
            const checked = fieldset.querySelector("input:checked");
            const labelNode = fieldset.querySelector("[data-option-label]");
            if (checked && labelNode) labelNode.textContent = checked.value;
          });
        }

        toggleAddButton(disabled) {
          if (!this.addButton || !this.addLabel) return;
          this.addButton.disabled = disabled;
          const nextLabel = disabled
            ? window.variantStrings?.soldOut || "Sold out"
            : window.variantStrings?.addToCart || "Add to cart";
          this.addLabel.textContent = nextLabel;
          this.addLabel.setAttribute("data-label", nextLabel);
        }

        renderPrice(priceCents, compareAtCents) {
          if (!this.priceWrap) return;
          const compareAtNumber = Number(compareAtCents || 0);
          const isOnSale = compareAtNumber > Number(priceCents || 0);
          const currentText = this.formatMoney(priceCents);
          const compareText = isOnSale ? this.formatMoney(compareAtNumber) : "";
          const priceRoot = this.priceWrap.querySelector(".price") || this.priceWrap;

          this.priceWrap
            .querySelectorAll(".price-item--sale, .price__regular .price-item--regular")
            .forEach((node) => {
              node.textContent = currentText;
            });

          const compareNode = this.priceWrap.querySelector(
            ".price__compare .price-item--regular"
          );
          if (compareNode) compareNode.textContent = compareText;

          priceRoot.classList.toggle("price--on-sale", isOnSale);
        }

        formatMoney(cents) {
          if (typeof window.formatMoney === "function") {
            return window.formatMoney(cents, this.moneyFormat);
          }

          const amount = Number(cents || 0) / 100;
          try {
            return new Intl.NumberFormat(window.Shopify?.locale || "en", {
              style: "currency",
              currency: window.Shopify?.currency?.active || "USD",
            }).format(amount);
          } catch (_) {
            return amount.toFixed(2);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
